<script>
    import BaseTooltip from "@main/packages/BaseTooltip";

    export default {
        name: "ProductCardIcons",
        components: { BaseTooltip },
        props: {
            icons: Object,
            isSmall: Boolean,
            isOdd: Boolean,
        },
        computed: {
            productIcons() {
                return Object.entries(this.icons)
                    .sort(([, a], [, b]) => a.sort - b.sort)
                    .map((entry) => {
                        const [name, value] = entry;
                        return { name, ...value };
                    })
                    .filter((icon) => icon.name !== "add-on");
            },
        },
    };
</script>

<template>
    <div class="product-card-icons" :class="{ 'product-card-icons--sm': isSmall }">
        <div
            class="product-card-icons__image"
            v-for="(icon, index) in productIcons"
            :key="index"
        >
            <img :src="`/static/igarden/icons/${icon.name}.svg`" alt="" />
            <base-tooltip
                class="product-card-icons__tooltip"
                :position-x="isOdd ? 'left' : 'right'"
                :position-y="isSmall ? 'bottom' : 'top'"
            >
                {{ icon.value.replace(" (igarden)", "") }}
            </base-tooltip>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-icons {
        position: relative;
        display: flex;
        margin: 0 -1px;
        padding: 2px 8px 4px;
        background-color: #fff;
        border-radius: 0 12px 0 12px;
        @include bp($bp-desktop-sm) {
            margin: 0 -4px;
            padding: 0;
            background-color: transparent;
            cursor: pointer;
        }
    }
    .product-card-icons--sm {
        margin: 0 -1px;
        padding: 2px 8px 4px;
        background-color: #fff;

        .product-card-icons__image {
            @include box(24px);
            margin: 0 1px;
        }
    }

    .product-card-icons__image {
        position: relative;
        z-index: 3;
        @include box(24px);
        &:hover {
            & > .product-card-icons__tooltip {
                display: block;
            }
        }
        @include bp($bp-desktop-sm) {
            @include box(40px);
        }
    }
</style>
